import { Col, Form, Input, Modal, Row, Select } from "antd";
import axios from "axios";
import { message } from "@bindeleddet/core/utils";
import { StudyProgram, StudentUser, UpdateStudentUser } from "@bindeleddet/core/types";
import { useEffect, useState } from "react";

const { Option } = Select;

interface Props {
  student: StudentUser;
  onSave: (Student: StudentUser) => void;
  onClose: () => void;
  isOpen: boolean;
}

const EditStudent: React.FC<Props> = ({ student, onSave, isOpen, onClose }) => {
  const [studyPrograms, setStudyPrograms] = useState<StudyProgram[]>([]);

  const [form] = Form.useForm();

  useEffect(() => {
    axios.get<StudyProgram[]>("/students/study-program/").then(response => setStudyPrograms(response.data));
  }, []);

  useEffect(() => {
    form.setFieldsValue(student);
  }, [student, form]);

  const updateStudent = () => {
    const values = form.getFieldsValue() as UpdateStudentUser;
    form
      .validateFields()
      .then(() => {
        axios
          .patch<StudentUser>(`/students/${student.id}/`, {
            ...student,
            ...values,
            updated_at: new Date().toISOString(),
          })
          .then(response => {
            onSave(response.data);
            message("success", "Student oppdatert");
          })
          .catch(() => {
            message("error", "Kunne ikke oppdatere student");
          });
      })
      .catch(() => {
        message("error", "Vennligst fyll ut alle obligatoriske felter");
      });
  };

  return (
    <Modal
      title={`Rediger ${student.first_name}`}
      open={isOpen}
      width="60%"
      onOk={updateStudent}
      okText="Lagre"
      cancelText="Avbryt"
      onCancel={onClose}
    >
      <Form form={form} layout="vertical" requiredMark onFinish={updateStudent}>
        <Row gutter={[16, 1]}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Fornavn"
              name="first_name"
              rules={[{ required: true, message: "Vennligst skriv inn fornavn" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Etternavn"
              name="last_name"
              rules={[{ required: true, message: "Vennligst skriv inn etternavn" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Mobilnummer"
              name="mobile_number"
              rules={[{ required: true, message: "Vennligst skriv inn telefonnummer" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Epost"
              name="email"
              rules={[
                { required: true, message: "Vennligst skriv inn epost" },
                { type: "email", message: "Ugyldig epost" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Linje"
              name="study_programme"
              rules={[{ required: true, message: "Vennligst velg linje" }]}
            >
              <Select>
                {studyPrograms.map(program => {
                  return (
                    <Option value={program.id} key={program.id}>
                      {program.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Årskull"
              name="year_level"
              rules={[{ required: true, message: "Vennligst velg årskull" }]}
            >
              <Select>
                <Option value={1}>1. klasse</Option>
                <Option value={2}>2. klasse</Option>
                <Option value={3}>3. klasse</Option>
                <Option value={4}>4. klasse</Option>
                <Option value={5}>5. klasse</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24}>
            {/* TODO sørg for at ikke brukernavn fylles inn som allergi automatisk */}
            <Form.Item
              label="Allergier"
              name="allergies"
              tooltip="Hvis studenten har flere allergier, skill med komma."
            >
              <Input autoComplete="allergies" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditStudent;
